import { tally } from './tally';
import { videoCall } from './videoCall';
import { videoTherapy } from './videoTherapy';

export const staticForms = {
  namespaced: true,
  modules: {
    tally,
    videoCall,
    videoTherapy
  }
};
